export default {
  banks: []
}



// WEBPACK FOOTER //
// ./src/components/bank/store/state.js